export default __webpack_public_path__ + "static/media/menuEditar.7a30c3d3.svg";